import React, { FunctionComponent, useState } from "react"
import { useTranslation } from "react-i18next"

import { Flex } from "components/Flex"
import Modal from "components/Modal/Modal"
import Button from "components/Button/Button"
import Input from "components/Input/Input"
import FormField from "components/FormField/FormField"

export interface ICopyAssetNotesFieldProps {
    label: string
    value: string
    testId?: string
    onChange(value: string): void
}

/**
 * Internal-notes field of the copy dialog: a single line that ellipsizes long
 * text and opens a large textarea editor on click, so multi-line notes stay
 * readable without stretching the card.
 */
const CopyAssetNotesField: FunctionComponent<React.PropsWithChildren<ICopyAssetNotesFieldProps>> = ({
    label,
    value,
    testId,
    onChange,
}) => {
    const { t } = useTranslation()
    const [draft, setDraft] = useState<string | null>(null)

    return (
        <>
            <FormField label={label}>
                <div className="copy-asset__notes-input" onClick={() => setDraft(value)}>
                    <Input
                        value={value}
                        placeholder={t('common.pleaseEnter')}
                        readOnly
                        data-testid={testId}
                    />
                </div>
            </FormField>
            {draft !== null &&
                <Modal
                    title={label}
                    onClose={() => setDraft(null)}
                    closeButton
                    maxWidth="640px"
                    footer={
                        <Flex justifyContent="flex-end" gap="2.4rem">
                            <Button
                                theme="secondary"
                                label={t('common.cancel')}
                                onClick={() => setDraft(null)}
                            />
                            <Button
                                label={t('common.apply')}
                                onClick={() => {
                                    onChange(draft)
                                    setDraft(null)
                                }}
                                data-testid="copy-asset-notes-apply"
                            />
                        </Flex>
                    }>
                    <Input
                        type="textarea"
                        rows={10}
                        maxLength={5000}
                        value={draft}
                        onChange={e => setDraft(e.target.value)}
                        data-testid="copy-asset-notes-editor"
                    />
                </Modal>
            }
        </>
    )
}

export default CopyAssetNotesField
